module.exports = __webpack_public_path__ + "static/agency-banner-f4b3e57b1ce581d5bb8584590be735da.png";